import React from "react";
import {Chart as ChartJS, ArcElement, Tooltip, Legend} from 'chart.js';
import NsDashboardCard from "../../../components/NsDashboardCard";
import Translate from "../../../components/Translate";
import {getStrRgba} from "../../../utility/common";

// Registrare i componenti necessari di Chart.js
ChartJS.register(ArcElement, Tooltip, Legend);

export default function DashboardKpiPendentiView({
                                                     info,
                                                     onClickStatoBozza,
                                                     onClickStatoCompleto,
                                                     onClickStatoApprovato,
                                                 }) {

    return (
        <NsDashboardCard
            title={'Inbox'}
            classiAggiuntive={"p-card--blu ns-card--h340"}
        >
            {
                info.da_compilare > 0 &&
                <button
                    className="row sost-stato-kpi sost-link w-100"
                    style={{
                        color: '#FFFFFF',
                        backgroundColor: getStrRgba(info.colore_da_compilare)
                    }}
                    onClick={onClickStatoBozza}>
                    <div className="col-2 sost-dashboard-num">
                        <i className={"fas fa-solid fa-clipboard-list"}/>
                    </div>
                    <div className="col-7 sost-dashboard-text">
                        <Translate>KPI da compilare</Translate>
                    </div>
                    <div className="col-3 text-end sost-dashboard-num">
                        {info.da_compilare}
                    </div>
                </button>
            }
            {
                info.da_approvare > 0 &&
                <button
                    className="row sost-stato-kpi sost-link w-100"
                    style={{
                        color: '#FFFFFF',
                        backgroundColor: getStrRgba(info.colore_da_approvare)
                    }}
                    onClick={onClickStatoCompleto}>
                    <div className="col-2 sost-dashboard-num">
                        <i className={"fas fa-signature"}/>
                    </div>
                    <div className="col-7 sost-dashboard-text">
                        <Translate>KPI da approvare</Translate>
                    </div>
                    <div className="col-3 text-end sost-dashboard-num">
                        {info.da_approvare}
                    </div>
                </button>
            }
            {
                info.da_revisionare > 0 &&
                <button
                    className="row sost-stato-kpi sost-link w-100"
                    style={{
                        color: '#FFFFFF',
                        backgroundColor: getStrRgba(info.colore_da_revisionare)
                    }}
                    onClick={onClickStatoApprovato}>
                    <div className="col-2 sost-dashboard-num">
                        <i className={"fas fa-user-check"}/>
                    </div>
                    <div className="col-7 sost-dashboard-text">
                        <Translate>KPI da revisionare</Translate>
                    </div>
                    <div className="col-3 text-end sost-dashboard-num">
                        {info.da_revisionare}
                    </div>
                </button>
            }
            {
                info.da_compilare == 0 && info.da_approvare == 0 && info.da_revisionare == 0 &&
                <div className="sost-dashboard-text">
                    <Translate>Nessuna attività pendente</Translate>
                </div>
            }
        </NsDashboardCard>
    );
}